<div class="license-item theme-licenses__itemMainBlock">
  <!-- Header block -->
  <div
    class="license-item__header-block theme-licenses__itemTopBlock"
    [ngClass]="{ 'license-item__header-block--recommended  theme-licenses__recommended': license.recommended }"
  >
    <h3 class="license-item__header-block-title bm--cut">{{ license.title }}</h3>
    <div class="license-item__header-block-price-box">
      <p class="license-item__header-block-price bm--cut">{{ license.price }}</p>
      @if (language === 'en') {
        <div class="btv-icon-sign-dollar"></div>
      }
      @if (language === 'ru') {
        <div class="btv-icon-sign-rub"></div>
      }
    </div>
  </div>

  <!-- License block -->
  <div class="license-item__list-container bm--scroll-bar">
    @if (license.features.length) {
      <ul class="license-item__list">
        @for (feature of license.features; track feature) {
          <li class="common-license-item common-license-item--big theme-licenses__itemListIcon-after">
            {{ feature.title }}
          </li>
        }
      </ul>
    } @else {
      <ul class="license-item__list">
        <li class="common-license-item common-license-item--big theme-licenses__itemListIcon-after">
          {{ lg.licenseBlock.noLicenseInfo }}
        </li>
      </ul>
    }
  </div>

  <!-- Footer block -->
  <div class="license-item__footer-block theme-licenses__itemBottomBlock">
    <div class="license-item__btn-container">
      @if (btnInLicenseName === 'to beat list') {
        <bmcore-button
          themeBtnClass="theme-btn__licenseBlock-showAllBeats"
          themeIconClass="theme-icon__licenseBlock-showAllBeats"
          title="{{ lg.button.toBeatList }}"
          [routerPath]="toBeatListBtnRoute"
          styleName="track"
          icon="{{ mobMode ? '' : 'btv-icon-cart' }}"
        >
        </bmcore-button>
      }
      @if (btnInLicenseName === 'add to cart') {
        <bmcore-button
          [themeBtnClass]="
            checkIsTrackWithSelectedLicenseInCart(license.beatId, license.id)
              ? 'theme-btn__licenseBlock-goToCart'
              : 'theme-btn__licenseBlock-addToCart'
          "
          [themeIconClass]="
            checkIsTrackWithSelectedLicenseInCart(license.beatId, license.id)
              ? 'theme-icon__licenseBlock-goToCart'
              : 'theme-icon__licenseBlock-addToCart'
          "
          title="{{
            checkIsTrackWithSelectedLicenseInCart(license.beatId, license.id) ? lg.button.goToCart : lg.button.addToCart
          }}"
          [routerPath]="checkIsTrackWithSelectedLicenseInCart(license.beatId, license.id) && checkoutPage"
          [styleName]="checkIsTrackWithSelectedLicenseInCart(license.beatId, license.id) ? 'in cart' : 'track'"
          (clickHandler)="addTrackToCart(license.beatId, license.id)"
          icon="{{ mobMode ? '' : 'btv-icon-cart' }}"
        >
        </bmcore-button>
      }
    </div>

    <bmcore-license-bulk-discount [lg]="lg" [licenseBulkDiscounts]="licenseBulkDiscounts" [trackLicense]="license">
    </bmcore-license-bulk-discount>
  </div>
</div>
